<template>
  <div v-if="reports" class="visits" aria-label="provider's visits">
    <div v-for="(report, index) in reports" :key="index" class="visit" aria-label="procedure description">
      <h2 class="visit-header">{{ report.date }} </h2>
      <div class="visit-detail capitalize">
        <p>{{ report.documentType.toLowerCase()}}
          <!--<router-link :to="'/reports/' + index" class="float-right">View report</router-link>-->
          <router-link :to="{ name: 'ReportNavigation', params: { selectedReport: report.id, fileType: FILE_TYPE } }" class="float-end">View report</router-link>
        </p>
        <p>{{ report.procedure }}</p>

      </div>
    </div>


  </div>
</template>

<script>
  import { REPORT_FILE_TYPE } from '@/config';

  export default {
    name: "ProviderVisits",
    props: {
      reports: Array,
    },
    data() {
      return {
        FILE_TYPE: REPORT_FILE_TYPE,
      }
    },
    beforeDestroy() {
      delete this.FILE_TYPE;
      this.FILE_TYPE = null;
    }
  }
</script>

<style scoped lang="scss">
  p {
    margin: 0;
    font-size: 0.9em;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .visit {
    padding: 0.7em 2em 0.7em;
  }
  .visit:first-child {
    padding-top: 1.5em;
  }
  .visit:last-child {
    padding-bottom: 1.5em;
  }
  .visit:nth-child(even) {
    background-color: #ececec;
  }
  .visit-header {
    font-weight: normal;
    font-size: 1.2em;
  }

</style>